export var accountTypes = {
  B2B: "01",
  B2C: "02"
};
export var userRoles = {
  B2B: accountTypes.B2B,
  B2C: accountTypes.B2C,
  ANONYMOUS: "anonymous"
};
export var addressTypes = {
  MAIN: "01",
  BILLING: "02"
};